import React from "react";

import "./SilentChatButton.css"

interface silentChatButtonProps {
    silentChatsId: number[],
    selectedChatId: number,
    onClick(): void
}

export default function SilentChatButton(props: silentChatButtonProps) {
    const isSilent = props.silentChatsId.findIndex(x => x === props.selectedChatId) > -1;

    const handlePressEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter") {
          props.onClick();
        }
    }

    return (
      <React.Fragment>
        <div onClick={props.onClick} tabIndex={0} onKeyDown={handlePressEnter}>
          <img
            alt=""
            src={
              isSilent
                ? require("./../../images/silent_chat_on.svg").default
                : require("./../../images/silent_chat_off.svg").default
            }
          />
        </div>
      </React.Fragment>
    );
}